// node modules
import dayjs from 'dayjs';

// modules
import { LStorage } from 'modules/Storage';
import { Holding } from 'modules/TradesPW3/Holdings/typings';

export const shouldShowNotificationAlert = (
) => {
  const reminderDate = LStorage.getItem('HOLDING_DISCREPANCY_REMINDER');
  const today = dayjs(new Date());
  const parsedReminderDate = dayjs(reminderDate, 'DD/MM/YYYY');

  return (
    (reminderDate && dayjs(today).isSameOrAfter(parsedReminderDate)) ||
    !reminderDate
  );
};

export const getDiscrepantHoldingsCount = (holdings: Holding[]) => {
  const discrepantHoldingsCount = holdings.reduce((acc, holding) => {
    if (holding.metaData?.isDpTransferred) {
      return acc + 1;
    }
    return acc;
  }, 0);

  return discrepantHoldingsCount;
};
